import { useState } from 'react';
import { Button } from '../../ui/Button';

/** "in 7 days" / "in 1 hour", from the server's expiresAt (rounded to the nearest unit). */
export function expiresIn(expiresAt: string, now = Date.now()): string {
  const ms = Math.max(0, Date.parse(expiresAt) - now);
  const hours = Math.round(ms / 3_600_000);
  if (hours < 24) {
    const h = Math.max(1, hours);
    return `in ${h} ${h === 1 ? 'hour' : 'hours'}`;
  }
  const days = Math.round(hours / 24);
  return `in ${days} ${days === 1 ? 'day' : 'days'}`;
}

/** A link the server shows once (invites, reset links), with a Copy button. */
export function OneTimeLink({ url, note }: { url: string; note: string }) {
  const [copy, setCopy] = useState<'idle' | 'copied' | 'failed'>('idle');
  return (
    <div className="flex flex-col gap-2 rounded-2xl bg-surface p-3">
      <code className="font-mono text-sm break-all">{url}</code>
      <p className="text-xs text-muted">{note}</p>
      <Button
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(url);
            setCopy('copied');
          } catch {
            setCopy('failed');
          }
        }}
      >
        Copy link
      </Button>
      {copy === 'copied' ? (
        <p role="status" className="text-xs text-success">
          Copied.
        </p>
      ) : null}
      {copy === 'failed' ? (
        <p role="status" className="text-xs text-muted">
          Couldn't copy. Select the link and copy it yourself.
        </p>
      ) : null}
    </div>
  );
}
